import { useState } from 'react';
import { DevicesTab } from './devices/DevicesTab';
import { ScreenshotsTab } from './devices/ScreenshotsTab';
import { HumanCheckTab } from './devices/HumanCheckTab';

type Tab = 'devices' | 'screenshots' | 'human';

const TABS: { value: Tab; label: string; hint: string }[] = [
  { value: 'devices', label: 'Devices', hint: 'Device security reports and SDK status' },
  { value: 'screenshots', label: 'Screenshots', hint: 'Скриншоты, снятые пользователями внутри приложений' },
  { value: 'human', label: 'Human check', hint: 'Проверка «человек или бот» после блокировки: насколько точно мы блокируем' },
];

export function Devices() {
  const [tab, setTab] = useState<Tab>('devices');
  const hint = TABS.find((t) => t.value === tab)!.hint;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-bold text-content">Devices</h1>
        <p className="text-sm text-content-subtle mt-1">{hint}</p>
      </div>

      <div className="flex gap-1 border-b border-border">
        {TABS.map((t) => (
          <button
            key={t.value}
            type="button"
            onClick={() => setTab(t.value)}
            className={`px-4 py-2 text-sm -mb-px border-b-2 ${
              tab === t.value
                ? 'border-primary text-content'
                : 'border-transparent text-content-muted hover:text-content'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'devices' ? <DevicesTab /> : tab === 'screenshots' ? <ScreenshotsTab /> : <HumanCheckTab />}
    </div>
  );
}
